<div class="page-navigation-menu" role="navigation">

    <!-- Menu Item List -->
    @if (menuItems$ | async; as menuItems) {
        <ol class="page-navigation-list">

            <!-- individual menu item -->
            @for (item of menuItems; track $index; let first = $first, last = $last) {
                <!-- <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item, page: page }"></ng-container> -->
                @if (item.visible()) {
                    <li
                        @expandCollapse @zoomIn @zoomOut
                        class="nav-item"
                        [ngClass]="{
                            'active-menu-item': activeMenuItem(item),
                            'first-menu-item': first,
                            'last-menu-item': last,
                        }">

                        @switch (canNavigate(item)) {
                            @case (true) {
                                <a
                                    class="page-menu-link nav-item-inner"
                                    [routerLink]="['.', { page: item.pageId }]"
                                    routerLinkActive="router-link-active">
                                    {{ item.title }}
                                </a>
                            }

                            @case (false) {
                                <div class="nav-item-inner">
                                    {{ item.title }}
                                </div>
                            }
                        }

                        @if (item.subItems?.length && activeMenuItem(item)) {
                            <ol class="sub-page-navigation-list">
                                @for (subItem of item.subItems; track subItem.sortIndex;) {
                                    @if (subItem.visible()) {
                                        <li
                                            @expandCollapse @zoomIn @zoomOut
                                            class="nav-item"
                                            [ngClass]="{
                                                'active-menu-item': activeMenuItem(subItem),
                                                'first-menu-item': first,
                                                'last-menu-item': last,
                                            }">
                                        @switch (canNavigate(subItem)) {
                                            @case (true) {
                                                <a
                                                    class="page-menu-link nav-item-inner"
                                                    [routerLink]="['.', { page: subItem.pageId, subPage: subItem.controlId }]"
                                                    routerLinkActive="router-link-active">
                                                    {{ subItem.title }}
                                                </a>
                                            }

                                            @case (false) {
                                                <div class="nav-item-inner">
                                                    {{ subItem.title }}
                                                </div>
                                            }
                                        }
                                        </li>
                                    }
                                }
                            </ol>
                        }
                    </li>
                }
            }
        </ol>
    }
</div>
